import { Button, Modal, Typography } from 'antd';

import { useSaveLessonMutation } from '@/services/savedLessons';

interface IProps {
  lessonId: number;
  open: boolean;
  onCancel: () => void;
}

const UnmarkConfirmation = (props: IProps) => {
  const [saveLesson, { isLoading }] = useSaveLessonMutation();

  const handleSubmit = () => {
    saveLesson(props.lessonId);
  };

  const footer = [
    <Button key='back' onClick={props.onCancel} disabled={isLoading} size='large'>
      Cancelar
    </Button>,
    <Button key='submit' type='primary' loading={isLoading} onClick={handleSubmit} size='large'>
      Confirmar
    </Button>
  ];

  return (
    <Modal title='Remover aula da lista' footer={footer} open={props.open} closable={false} width={420} centered>
      <Typography.Paragraph>Deseja remover esta aula da sua lista de aulas salvas?</Typography.Paragraph>
    </Modal>
  );
};

export default UnmarkConfirmation;
